// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__bnOfR","ellipsis":"styles_ellipsis__DyW1D","text2AndMoreLines":"styles_text2AndMoreLines__9C_1G","tooltipTrigger":"styles_tooltipTrigger__7okXh"};